// extracted by mini-css-extract-plugin
module.exports = {"GetSupport":"get-support_GetSupport__1i1rW"};